import { ChevronUpIcon } from "lucide-react";

import { Badge } from "@kit/ui/badge";
import { Trans } from "@kit/ui/trans";

export function IssueVotesBadge(props: { votes: number }) {
  return (
    <Badge variant={"outline"} className={"flex gap-1"}>
      <ChevronUpIcon
        className={"bg-primary text-primary-foreground h-3 w-3 rounded-full"}
      />

      <span>
        <Trans
          i18nKey={"roadmap:votes"}
          defaults={`${props.votes} votes`}
          values={{ votes: props.votes }}
        />
      </span>
    </Badge>
  );
}
